import React from "react";
import { Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import IconComponent from "./IconComponent";

interface Props {
  name: string;
  description: string;
  newRow?: boolean;
  alignItems?: string;
}

const DescriptionTypography = ({ name, description, newRow, alignItems }: Props) => {
  return (
    <Stack direction={"row"} alignItems={alignItems ? alignItems : "center"} spacing={1}>
      <Box>
        <IconComponent iconName={"DotFilled"} hasStroke />
      </Box>
      <Typography sx={{ fontSize: "12px", width: "100%" }} variant="body2" color={"textSecondary"}>
        <b>{name}</b> {` `} {newRow && <br></br>}
        <span style={{ opacity: 0.5 }}>{description}</span>
      </Typography>
    </Stack>
  );
};

export default DescriptionTypography;
